module.exports = __webpack_public_path__ + "0525faa29d863244ff7acf6755e08bb0.svg";